import React, {useState} from 'react';
import './styles.scss'
import HeaderButton from "../pages/reports/components/button";
import {apiPost} from "../services/apiClient";
import {toast} from "react-toastify";
import ConfirmModal from "../components/Modals/ConfirmModal";

const DictionaryButtons = ({reload, selectedItems, clearFilters, clearDisabled, dictionaryData, setLoading}) => {
    const [deleteItems, setDelete] = useState(false);
    const deleteParcels = () => {
        setLoading(true);
        apiPost(`${dictionaryData.key}/delete`, {ids: selectedItems}).then(d => {
            d.warnings && toast.error(d.warnings)
            setDelete(false);
            !d.warnings && toast.success('Строки удалены')
            reload ? reload() : setLoading(false);
        }).catch(e => {
            setDelete(false);
            toast.error('При удалении произошла ошибка')
            setLoading(false)
            console.log(e)
        })
    }

    const [setDelivered, setSetDelivered] = useState(false);
    const setDeliveredStatus = () => {
        setLoading(true);
        apiPost(`incoming-parcels/set-delivered-status`, { ids: selectedItems })
            .then(() => {
                toast.success('Статус "Вручено" установлен');
                setSetDelivered(false);
                reload ? reload() : setLoading(false);
            })
            .catch(e => {
                setSetDelivered(false);
                toast.error('Ошибка при смене статуса');
                setLoading(false);
                console.log(e);
            });
    };

    return (
        <div className='grid-btns'>
            <HeaderButton
                disabled={!selectedItems.length}
                icon='delete'
                name='Удалить'
                onClick={() => setDelete(true)}
            />
            <HeaderButton
                disabled={clearDisabled}
                icon='close'
                name='Сбросить фильтры'
                onClick={clearFilters}
            />
            <HeaderButton
                disabled={!selectedItems.length}
                icon='check'
                name='Вручить выбранные'
                onClick={() => setSetDelivered(true)}
            />
            <ConfirmModal
                open={deleteItems}
                setOpen={setDelete}
                label={`Удаление`}
                onConfirm={deleteParcels}
            >
                Вы уверены, что хотите удалить выбранные строки?
            </ConfirmModal>
            <ConfirmModal
                open={setDelivered}
                setOpen={setSetDelivered}
                label={`Подтвердите смену статуса`}
                onConfirm={setDeliveredStatus}
            >
                Вы уверены, что хотите установить статус "Вручено" для выбранных строк?
            </ConfirmModal>
        </div>
    );
};

export default DictionaryButtons;


// WEBPACK FOOTER //
// ./App/grids/dictionaryButtons.jsx